import { render, staticRenderFns } from "./AnularRecibo.vue?vue&type=template&id=a5a0559a"
import script from "./AnularRecibo.vue?vue&type=script&lang=js"
export * from "./AnularRecibo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports